<script lang="ts" setup>
import { graphql } from '@/gql';
import TermOfServiceTemplate from '~/components/templates/TermOfServiceTemplate/TermOfServiceTemplate.vue';

const { data } = useAsyncQuery(
  graphql(`
    query TOSPage {
      term(type: TERMS_OF_SERVICE) {
        ...TermOfServiceTemplateTermRevision
      }
    }
  `)
);

useAppMeta({
  title: '利用規約',
});
</script>

<template>
  <TermOfServiceTemplate v-if="data != null" :term="data.term" />
</template>
